export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.user-manager': 'User Management',
  'menu.user-manager.agent': 'Agent Management',
  'menu.user-manager.partner': 'Partner',
  'menu.user-manager.normal-user': 'Regular User',
  'menu.shop-manager': 'Shop Management',
  'menu.shop-manager.plans': 'Plans',
  'menu.shop-manager.cards': 'Cards',
  'menu.provider-manager': 'Provider Management',
  'menu.provider-manager.provider-list': 'Provider List',
  'menu.provider-manager.cost-list': 'Cost List',
  'menu.orders': 'Orders',
  'menu.finance-manager': 'Finance',
  'menu.finance-manager.recharge-review': 'Recharge Review',
  'menu.finance-manager.withdraw-review': 'Withdraw Review',
  'menu.system-settings': 'System Settings',
  'menu.system-settings.region': 'Region',
  'menu.system-settings.sys-log': 'Operation Log',
};
